"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimezoneOption = exports.parseTimezone = exports.formatTimezone = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _func = require("../utils/func");

var _time = _interopRequireDefault(require("../utils/time"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TIMEZONE_PARTS_DELIMITER = ' - ';

var formatTimezone = function formatTimezone(timezone) {
  if (!timezone || !timezone.city || !timezone.zoneAbbr) return '';
  return "".concat(timezone.city).concat(TIMEZONE_PARTS_DELIMITER).concat(timezone.zoneAbbr);
};

exports.formatTimezone = formatTimezone;

var parseTimezone = function parseTimezone(timezoneDisplay) {
  if (!timezoneDisplay) return undefined;
  var delimiterStart = timezoneDisplay.indexOf(TIMEZONE_PARTS_DELIMITER);
  var delimiterEnd = delimiterStart + TIMEZONE_PARTS_DELIMITER.length;
  var city = timezoneDisplay.substring(0, delimiterStart);
  var zoneAbbr = timezoneDisplay.substring(delimiterEnd);
  if (!city || !zoneAbbr) return undefined;
  return {
    city: city,
    zoneAbbr: zoneAbbr
  };
};

exports.parseTimezone = parseTimezone;

var TimezoneOption = function TimezoneOption(item, isHighlighted) {
  return _react.default.createElement("div", {
    key: "".concat(item.zoneName, "-").concat(item.zoneAbbr),
    className: (0, _dedupe.default)('timezone-option', {
      'timezone-option__highlighted': isHighlighted
    })
  }, formatTimezone(item));
};

exports.TimezoneOption = TimezoneOption;

var TimezoneAutocomplete =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TimezoneAutocomplete, _React$PureComponent);

  function TimezoneAutocomplete(props) {
    var _this;

    _classCallCheck(this, TimezoneAutocomplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimezoneAutocomplete).call(this, props));
    var minLength = _this.props.minLength;

    var guessedTimezone = _time.default.guessUserTz();

    _this.state = {
      timezone: formatTimezone(guessedTimezone)
    };
    _this.handleTimezoneChange = _this.handleTimezoneChange.bind(_assertThisInitialized(_this)); // create partial function passing in the minLength argument

    _this.shouldItemRenderAfterMinLengthEntered = function (timezoneItem, searchValue) {
      return _time.default.isValueInCityOrZone(timezoneItem, searchValue, minLength);
    };

    return _this;
  }

  _createClass(TimezoneAutocomplete, [{
    key: "handleTimezoneChange",
    value: function handleTimezoneChange(selection) {
      var onTimezoneChange = this.props.onTimezoneChange;

      var _parseTimezone = parseTimezone(selection),
          city = _parseTimezone.city,
          zoneAbbr = _parseTimezone.zoneAbbr;

      var zoneObject = (0, _func.head)(_time.default.tzSearch({
        city: city,
        zoneAbbr: zoneAbbr
      }));

      if (zoneObject) {
        this.setState({
          timezone: formatTimezone(zoneObject)
        });
        if (onTimezoneChange) onTimezoneChange(zoneObject);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          inputProps = _this$props.inputProps,
          menuStyle = _this$props.menuStyle,
          onMenuVisibilityChange = _this$props.onMenuVisibilityChange,
          wrapperProps = _this$props.wrapperProps;
      var timezone = this.state.timezone;
      return _react.default.createElement(_reactAutocomplete.default, {
        onChange: function onChange(event, value) {
          return _this2.setState({
            timezone: value
          });
        },
        onSelect: function onSelect(value) {
          return _this2.handleTimezoneChange(value);
        },
        onMenuVisibilityChange: onMenuVisibilityChange,
        menuStyle: menuStyle,
        inputProps: _objectSpread({
          id: 'timezone-picker-search-input'
        }, inputProps),
        wrapperProps: wrapperProps,
        items: _time.default.tzMaps,
        shouldItemRender: this.shouldItemRenderAfterMinLengthEntered,
        getItemValue: formatTimezone,
        sortItems: _time.default.compareByCityAndZone,
        renderItem: TimezoneOption,
        value: timezone
      });
    }
  }]);

  return TimezoneAutocomplete;
}(_react.default.PureComponent);

TimezoneAutocomplete.defaultProps = {
  onTimezoneChange: function onTimezoneChange() {},
  onMenuVisibilityChange: function onMenuVisibilityChange() {},
  inputProps: {},
  menuStyle: {},
  wrapperProps: {},
  minLength: 3
};
TimezoneAutocomplete.propTypes = {
  onTimezoneChange: _propTypes.default.func,
  onMenuVisibilityChange: _propTypes.default.func,
  inputProps: _propTypes.default.object,
  menuStyle: _propTypes.default.object,
  wrapperProps: _propTypes.default.object,
  minLength: _propTypes.default.number
};
var _default = TimezoneAutocomplete;
exports.default = _default;